import React from 'react';

import Step from 'components/stepper/Step';

import RequestBody from './RequestBody';

const RequestStep = ({
  goToPreviousStep,
  pageTitle,
  exitPage,
  recipe,
  idempotencyToken,
}) => {
  return (
    <Step
      key="request"
      onBackButtonClick={goToPreviousStep}
      stepTitle={pageTitle}
      spacing={8}
      renderBody={() => {
        return (
          <RequestBody
            exitPage={exitPage}
            recipe={recipe}
            idempotencyToken={idempotencyToken}
          ></RequestBody>
        );
      }}
    ></Step>
  );
};

export default RequestStep;
